import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Typography, Dialog, DialogContent, Radio } from "@mui/material";
import SendTextMessagePopUp from "./SendTextMessagePopUp";
import SendEmailMessagePopUp from "./SendEmailMessagePopUp";
import CouponQRCode from "../../components/CouponQRCode";

const SendSavingsPOS = (props) => {
  const {
    sharePOSCoupon,
    setShowSharePOSPopup,
    couponData,
    productType,
    sendEmailMessageInfoIsProgress,
    sendTextMessageInfoIsProgress,
  } = props;
  const [textCouponType, setTextCouponType] = useState(
    couponData?.qrCodeUrl ? "qrcode" : "text"
  );
  const [showSendTextMessage, setShowSendTextMessage] = useState(
    couponData?.qrCodeUrl ? true : false
  );
  const [showSendEmailMessage, setShowSendEmailMessage] = useState(false);
  const [showQRCode, setShowQRCode] = useState(
    !couponData?.qrCodeUrl ? true : false
  );

  const radioBtnHandleChange = (event) => {
    const val = event?.target?.value || event;
    if (event?.target?.value) {
      setTextCouponType(val);
    }
    setShowSendTextMessage(false);
    setShowSendEmailMessage(false);
    setShowQRCode(false);

    if (val === "qrcode") {
      setShowQRCode(true);
    } else if (val === "text") {
      setShowSendTextMessage(true);
    } else if (val === "email") {
      setShowSendEmailMessage(true);
    }
  };

  const radioControlProps = (item) => ({
    checked: textCouponType === item,
    onChange: radioBtnHandleChange,
    value: item,
    name: "location-type-radio-button",
    inputProps: { "aria-label": item },
  });

  useEffect(() => {
    radioBtnHandleChange(textCouponType);
  }, [textCouponType]);

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={sharePOSCoupon}
        className="app-dialog"
        onClose={() => {}}
      >
        <DialogContent
          sx={{
            display: "grid",
            justifyContent: "center",
          }}
        >
          <Typography
            variant="h2LatoBold"
            sx={{
              fontFamily: "Lato",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            Send savings by{" "}
            {showQRCode ? "QR Code" : showSendTextMessage ? "text" : "email"}
          </Typography>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <>
              {couponData?.qrCodeUrl && (
                <>
                  <Radio {...radioControlProps("qrcode")} color="success" />
                  <Typography
                    variant="h2LatoMedium"
                    sx={{
                      fontWeight: 500,
                      fontSize: 16,
                      textAlign: "center",
                      color: "#607277",
                    }}
                  >
                    QR Code
                  </Typography>
                </>
              )}
              <Radio
                disabled={
                  sendTextMessageInfoIsProgress ||
                  sendEmailMessageInfoIsProgress
                }
                {...radioControlProps("text")}
                color="success"
              />
              <Typography
                variant="h2LatoMedium"
                sx={{
                  fontWeight: 500,
                  fontSize: 16,
                  textAlign: "center",
                  color: "#607277",
                }}
              >
                Text
              </Typography>
            </>
            <>
              <Radio
                disabled={
                  sendTextMessageInfoIsProgress ||
                  sendEmailMessageInfoIsProgress
                }
                {...radioControlProps("email")}
                color="success"
              />
              <Typography
                variant="h2LatoMedium"
                sx={{
                  fontWeight: 500,
                  fontSize: 16,
                  textAlign: "center",
                  color: "#607277",
                }}
              >
                Email
              </Typography>
            </>
          </div>

          {showQRCode && couponData?.qrCodeUrl && (
            <CouponQRCode
              popupContentOnly={true}
              onCancel={() => {
                setShowQRCode(false);
                setTextCouponType(false);
                setShowSharePOSPopup(false);
              }}
            />
          )}

          {showSendTextMessage && (
            <SendTextMessagePopUp
              productType={productType}
              fromSendSavinsgPOS={true}
              showTextCoupon={true}
              couponData={couponData}
              showSendTextMessage={showSendTextMessage}
              onCancel={() => {
                setShowSendTextMessage(false);
                setShowSharePOSPopup(false);
              }}
              onSendPhoneMessage={() => {
                setShowSendTextMessage(false);
              }}
            />
          )}
          {showSendEmailMessage && (
            <SendEmailMessagePopUp
              productType={productType}
              fromSendSavinsgPOS={true}
              showTextCoupon={true}
              couponData={couponData}
              showSendEmailMessage={showSendEmailMessage}
              onCancel={() => {
                setShowSendEmailMessage(false);
                setShowSharePOSPopup(false);
              }}
              onSendEmailMessage={() => {
                setShowSendEmailMessage(false);
              }}
            />
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    sendTextMessageInfoIsProgress: state.sendTextMessageInfo.isProgress,
    sendEmailMessageInfoIsProgress: state.sendEmailMessageInfo.isProgress,
  };
};

export default connect(mapStateToProps)(SendSavingsPOS);
